/* import __COLOCATED_TEMPLATE__ from './item.hbs'; */
/**

## Selector Control Navigation Item

**Contextual Component** This component is not intended to be used as a standalone. Checkout it's potential parent components for usage instead:
- [Selector Control](../../selector-control.html)

The Selector Navigation Item is a component that wraps around one of the following components:
- [Tab](./item/tab.html)
- [Segment](./item/segment.html)
- [Step](./item/step.html)

It is designed to be used within the [navigation](../navigation.html) component of a [Selector Control](../../selector-control.html)
and purposefully does not include any examples.

@param {String} key - Identifying key for this nav item.
@param {String} label - Text for this nav item. Can also pass a block instead.
@param {String} [type="TAB"] - The UI pattern to use for this nav item: `TAB`, `SEGMENT`, or `STEP`
@param {Boolean} isActive=false - Determines whether or not the tab is in an active state initially
*/

import Component from '@ember/component';
import { computed } from '@ember/object';
import { assert } from '@ember/debug';
import { isPresent } from '@ember/utils';
import TabItem from './item/tab';
import StepItem from './item/step';
import SegmentItem from './item/segment';
export const SELECTOR_TYPE = {
  TAB: 'TAB',
  STEP: 'STEP',
  SEGMENT: 'SEGMENT'
};

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  tagName: '',
  type: SELECTOR_TYPE.TAB,
  key: null,
  isActive: computed('key', 'activeItems', function () {
    return this.get('activeItems').includes(this.get('key'));
  }),
  itemComponent: computed('type', function () {
    switch (this.type) {
      case SELECTOR_TYPE.TAB:
        return TabItem;
      case SELECTOR_TYPE.STEP:
        return StepItem;
      case SELECTOR_TYPE.SEGMENT:
        return SegmentItem;
      default:
        return TabItem;
    }
  }),
  didReceiveAttrs() {
    this._super();
    assert('{{selector-control/navigation/item}} requires either a `key` or a `label` as a unique identifier. You passed neither.', isPresent(this.get('label')) || isPresent(this.get('key')));

    // If we don't have a key, then use the label as the key. If we have neither
    // then assert that one must be passed
    if (!this.get('key') && this.get('label')) {
      this.set('key', this.get('label'));
    }
  },
  actions: {
    onSelect() {
      this.get('onSelect')(this.get('key'));
    }
  }
});